import { createRoot } from 'react-dom/client';
import React, { StrictMode } from 'react';

import ProfileMaintenance from "./ProfileMaintenance";

/**
 * @param {Element} element element to inject dashboard into
 */
export function initProfileMaintenance(element) {
	const root = createRoot(element);
	root.render(
	<StrictMode>
		<ProfileMaintenance />
	</StrictMode>
	);
}